export default __webpack_public_path__ + "static/gemEmailAi-noBorder-05bd724ab549dda4c5ea62c7045891df.webp";